import axios from 'axios'

const HTTP = axios.create({
  baseURL: process.env.API_SERVER,
})

// http 요청
HTTP.interceptors.response.use(response => {
  return response
}, error => {
  if (!error.response) {
    return error
  }
  // 권한이 없는 경우 처리
  if (error.response.status === 401) {
    //place your reentry code
    //console.log('401')

    const location1 = window.location
    const location = `${location1.protocol}//${location1.host}/#/login`
    setTimeout(() => {
      location1.href = location
    }, 100)
  }
  return error
})

export default HTTP



// WEBPACK FOOTER //
// ./src/api/api.js